/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/templated_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTemplatedPreview } from "./constants";
import type { PostTemplatedPreviewRequestProps, PostTemplatedPreviewServerResult } from "./types";

export const getEngagementAppGroupIdTemplatedPreview = reactQueryFetcherAdapter(
  engagementAppGroupIdTemplatedPreview,
  (
    signal: AbortSignal,
    { appGroupId, ...templatedPreviewData }: PostTemplatedPreviewRequestProps
  ): Promise<PostTemplatedPreviewServerResult> => {
    return fetch(`/engagement/${appGroupId}/templated_preview`, "POST", templatedPreviewData, { signal });
  },
  // this should be a validator but it is far too complex to vibe code
  () => true
);
